import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { ShippingRateLima } from "../../../Domain/Model/ShippingRateLima";
import { ShippingRateProvince } from "../../../Domain/Model/ShippingRateProvince";
import ShippingDataSource from "../ShippingDataSource";

const routeName = `v1/Shipping/rates`;

export default class ShippingAPIDataSourceImpl implements ShippingDataSource {

    async getShippingRatesProvince(): Promise<ShippingRateProvince[]> {
        try {
            const response = await api.get<ApiResponse<any>>(`${routeName}/province`);
            const data = response.data?.data;

            const items = Array.isArray(response.data)
                ? response.data
                : Array.isArray(data)
                    ? data
                    : Array.isArray(data?.items)
                        ? data.items
                        : Array.isArray(data?.Items)
                            ? data.Items
                            : null;

            if (items && Array.isArray(items)) {
                return items.map((item: ShippingRateProvince) => ({
                    id: item.id,
                    region: item.region,
                    accessLevel: item.accessLevel,
                    size: item.size,
                    price: item.price,
                }));
            }
            throw new Error("La respuesta no tiene el formato esperado");
        } catch (error) {
            console.error("Error al obtener las tarifas de envío por provincia:", error);
            throw new Error("Error al obtener las tarifas de envío por provincia");
        }
    }

    async getShippingRatesLima(): Promise<ShippingRateLima[]> {
        try {
            const response = await api.get<ApiResponse<any>>(`${routeName}/lima`);
            const data = response.data?.data;

            const items = Array.isArray(response.data)
                ? response.data
                : Array.isArray(data)
                    ? data
                    : Array.isArray(data?.items)
                        ? data.items
                        : Array.isArray(data?.Items)
                            ? data.Items
                            : null;

            if (items && Array.isArray(items)) {
                return items.map((item: ShippingRateLima) => ({
                    id: item.id,
                    zone: item.zone,
                    size: item.size,
                    price: item.price,
                    isEstimated: item.isEstimated,
                }));
            }
            throw new Error("La respuesta no tiene el formato esperado");
        } catch (error) {
            console.error("Error al obtener las tarifas de envío para Lima:", error);
            throw new Error("Error al obtener las tarifas de envío para Lima");
        }
    }
}